import axiosInstance from '../utils/axiosConfig'
import { mobileBackendUrl } from '../env'

export enum InfiniteStatusEnum {
  ACCESS_OPEN = 'ACCESS_OPEN',
  ELIGIBLE = 'ELIGIBLE',
  ELIGIBLE_WITH_CALLBACK = 'ELIGIBLE_WITH_CALLBACK',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  REJECTED = 'REJECTED',
  JOINED_WAITLIST = 'JOINED_WAITLIST',
  JOINED_WAITLIST_WITH_CALLBACK = 'JOINED_WAITLIST_WITH_CALLBACK',
  NEVER_ONBOARDED = 'NEVER_ONBOARDED',
  ONBOARDED = 'ONBOARDED'
}

type PostInfiniteStatusRequest = {
  status?: InfiniteStatusEnum
}

type InfiniteStatusResponse = {
  onboardingStatus?: InfiniteStatusEnum
}

export const postInfiniteStatus = (body: PostInfiniteStatusRequest) => {
  return axiosInstance.post(`${mobileBackendUrl}/v2/portfolio/infinite-status`, body)
}

export const fetchInfiniteStatus = async (): Promise<InfiniteStatusResponse> => {
  const response = await axiosInstance.get(`${mobileBackendUrl}/v2/portfolio/infinite-status`)
  return (response?.data ?? {}) as InfiniteStatusResponse
}
